export default __webpack_public_path__ + "static/media/skillpaca_logo.d1064155.png";